"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontWeightEnum;
(function (FontWeightEnum) {
    FontWeightEnum[FontWeightEnum["thin"] = 100] = "thin";
    FontWeightEnum[FontWeightEnum["extraLight"] = 200] = "extraLight";
    FontWeightEnum[FontWeightEnum["light"] = 300] = "light";
    FontWeightEnum[FontWeightEnum["normal"] = 400] = "normal";
    FontWeightEnum[FontWeightEnum["medium"] = 500] = "medium";
    FontWeightEnum[FontWeightEnum["semiBold"] = 600] = "semiBold";
    FontWeightEnum[FontWeightEnum["bold"] = 700] = "bold";
    FontWeightEnum[FontWeightEnum["extraBold"] = 800] = "extraBold";
    FontWeightEnum[FontWeightEnum["black"] = 900] = "black";
})(FontWeightEnum = exports.FontWeightEnum || (exports.FontWeightEnum = {}));
